var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-select',{attrs:{"value":_vm.value,"resource":"cloudregions","need-params":"","filterable":"","params":_vm.params},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }